import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessMessageComponent } from './success-message/success-message.component';

@Injectable({ providedIn: 'root' })
export class SuccessToastService {
  private snackBar = inject(MatSnackBar);

  success(message: string, duration = 3000): void {
    const msg = (message || '').toString().trim();
    if (!msg) return;

    this.snackBar.openFromComponent(SuccessMessageComponent, {
      data: { message: msg },
      duration,
      panelClass: ['success-snackbar']
    });
  }
}
